import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AccessVisibility, SystemEntity } from '@wdx/clmi/clmi-swagger-gen';
import { CrudStatus, WdxDestroyClass } from '@wdx/shared/utils';
import { map, Observable } from 'rxjs';
import { distinctUntilChanged, tap, withLatestFrom } from 'rxjs/operators';
import * as visibilityActions from '../../../../../state/visibility/visibility.actions';
import * as visibilitySelectors from '../../../../../state/visibility/visibility.selectors';

@Injectable({
    providedIn: 'root',
})
export class AccessVisibilityFacade extends WdxDestroyClass {
    private readonly store$ = inject(Store);

    constructor() {
        super();
    }

    getAccessVisibility$(entityType: SystemEntity, entityId: string): Observable<AccessVisibility[]> {
        return this.store$.select(visibilitySelectors.getVisibilityForId(entityType, entityId)).pipe(
            withLatestFrom(this.getAccessVisibilityStatus$(entityType, entityId)),
            distinctUntilChanged(),
            tap(([accessVisibility, status]) => {
                // eslint-disable-next-line no-extra-boolean-cast
                if (!Boolean(status) || status === CrudStatus.Initial || (!accessVisibility && status >= CrudStatus.Success)) {
                    this.store$.dispatch(visibilityActions.getVisibilityForId({entityType, entityId}));
                }
            }),
            map(([accessVisibility]) => accessVisibility)
        );
    }

    getAccessVisibilityStatus$(entityType: SystemEntity, entityId: string): Observable<CrudStatus> {
        return this.store$.select(visibilitySelectors.getVisibilityForIdStatus(entityType, entityId));
    }
}
